










import { Vue, Component, Prop } from "vue-property-decorator";

// Data
import { DataModules } from "@/store/modules/data";

// Types
import { IProvisionRequest } from "@/models/provisioning";

@Component
export default class UProvisionRequestLink extends Vue {
  // Props

  @Prop({ required: true })
  public request!: IProvisionRequest;

  @Prop({ required: true })
  public canCancel!: boolean;

  // Computed

  public get link() {
    return {
      type: "a",
      events: {
        click: () => {
          this.$store.dispatch(
            `data/${DataModules.PROVISIONING_CONTRACT_PRODUCTS}/openRequestModal`,
            {
              props: {
                request: this.request,
                canCancel: this.canCancel
              }
            }
          );
        }
      }
    };
  }
}
